
import React, { useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Home, ArrowLeft, Search, FileQuestion } from 'lucide-react';

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    // Silent error tracking - removed console.error
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 via-blue-50 to-purple-50 px-4">
      <Card className="max-w-2xl w-full text-center shadow-xl">
        <CardContent className="pt-12 pb-8">
          {/* 404 Icon */}
          <div className="w-24 h-24 mx-auto mb-6 bg-gradient-to-br from-blue-100 to-purple-100 rounded-full flex items-center justify-center">
            <FileQuestion className="w-12 h-12 text-blue-600" />
          </div>

          {/* Main Error Message */}
          <div className="space-y-4 mb-8">
            <h1 className="text-6xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
              404
            </h1>
            <h2 className="text-2xl font-semibold text-gray-800">
              Page Not Found
            </h2>
            <p className="text-gray-600 max-w-md mx-auto leading-relaxed">
              Sorry, we couldn't find the page you're looking for. The page might have been moved, deleted, or you entered the wrong URL.
            </p>
          </div>

          {/* Current Path Display */}
          <div className="bg-gray-100 rounded-lg p-3 mb-8 mx-4">
            <p className="text-sm text-gray-500">Requested path:</p>
            <code className="text-sm font-mono text-gray-800 break-all">
              {location.pathname}
            </code>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 justify-center items-center">
            <Button asChild size="lg" className="w-full sm:w-auto">
              <Link to="/" className="flex items-center gap-2">
                <Home className="w-4 h-4" />
                Go Home
              </Link>
            </Button>
            
            <Button asChild variant="outline" size="lg" className="w-full sm:w-auto">
              <Link to="/search" className="flex items-center gap-2">
                <Search className="w-4 h-4" />
                Search Games
              </Link>
            </Button>
            
            <Button 
              variant="ghost" 
              size="lg" 
              onClick={() => window.history.back()}
              className="w-full sm:w-auto flex items-center gap-2"
            >
              <ArrowLeft className="w-4 h-4" />
              Go Back
            </Button>
          </div>

          {/* Help Text */}
          <div className="mt-8 pt-6 border-t border-gray-200">
            <p className="text-sm text-gray-500">
              Need help? Try searching for games or{' '}
              <Link to="/categories" className="text-blue-600 hover:underline">
                browse our categories
              </Link>
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default NotFound;
